export default __webpack_public_path__ + "static/media/05-Call Centers.f35de5e5.jpg";